import types from '../types'
import {getGraphs} from './getGraphs'

export const getAuthKey = (database, orgId) => (dispatch, getState) => {
  const dbRef = database
      .ref(`organizations/${orgId}/activeApis/genericFormApi/authToken`)
  dbRef.get()
      .then((snapshot) => {
        const val = snapshot.val()
        if (val) {
          const authForm = getState().userReducer.authForm
          dispatch({
            type: types.STORE_PAYLOAD,
            payload: {
              authForm: {
                ...authForm,
                authKey: val,
              },
            },
          })
        }
        dispatch(getGraphs(database, getState().userReducer.userId))
      })
      .catch((err) => {
        console.log('err: ', err)
      })
}
